// src/lib/phoneUtils.js

/**
 * Sanitizes and validates Turkish mobile numbers for Firebase Phone Authentication (E.164)
 * Handles dirty formats like "+90 (532) 123 45 67", "05321234567", "532-123-4567", etc.
 */
export const sanitizeTurkishPhone = (rawPhone) => {
    if (!rawPhone || typeof rawPhone !== 'string') {
        return {
            isValid: false,
            e164: '',
            digits: '',
            formatted: '',
            error: 'Lütfen bir cep telefonu numarası giriniz.'
        };
    }

    // Keep only numeric characters
    let digits = rawPhone.replace(/\D/g, '');

    // Handle leading 0090
    if (digits.startsWith('0090')) {
        digits = digits.slice(4);
    }
    // Handle leading 90 (if length is 12 or more)
    else if (digits.startsWith('90') && digits.length >= 12) {
        digits = digits.slice(2);
    }
    // Handle leading 0 (if length is 11)
    else if (digits.startsWith('0') && digits.length === 11) {
        digits = digits.slice(1);
    }

    // After stripping prefixes, standard Turkish mobile numbers are exactly 10 digits starting with '5'
    if (digits.length === 0) {
        return {
            isValid: false,
            e164: '',
            digits: '',
            formatted: '',
            error: 'Telefon numarası boş bırakılamaz.'
        };
    }

    if (digits.length !== 10) {
        return {
            isValid: false,
            e164: '',
            digits,
            formatted: digits,
            error: `Telefon numarası 10 haneli olmalıdır (Örn: 5XX XXX XX XX). Girilen: ${digits.length} hane.`
        };
    }

    if (!digits.startsWith('5')) {
        return {
            isValid: false,
            e164: '',
            digits,
            formatted: digits,
            error: 'Türkiye cep telefonu numaraları 5 ile başlamalıdır (Örn: 532...).'
        };
    }

    const formatted = `0 (${digits.slice(0, 3)}) ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8, 10)}`;
    const e164 = `+90${digits}`;

    return {
        isValid: true,
        e164,
        digits,
        formatted,
        error: ''
    };
};

/**
 * Format phone as user types (e.g. "532 123 45 67")
 */
export const formatPhoneInput = (val) => {
    if (!val) return '';
    let digits = val.replace(/\D/g, '');
    if (digits.startsWith('90') && digits.length > 10) {
        digits = digits.slice(2);
    } else if (digits.startsWith('0')) {
        digits = digits.slice(1);
    }
    digits = digits.slice(0, 10);

    let parts = [];
    if (digits.length > 0) parts.push(digits.slice(0, 3));
    if (digits.length > 3) parts.push(digits.slice(3, 6));
    if (digits.length > 6) parts.push(digits.slice(6, 8));
    if (digits.length > 8) parts.push(digits.slice(8, 10));

    return parts.join(' ');
};

/**
 * Resolves contact fields whether they are strings, legacy formats, or { value, isVisible } objects
 */
export const resolveContactField = (fieldData) => {
    if (!fieldData) return { value: '', isVisible: false };
    if (typeof fieldData === 'string') {
        const trimmed = fieldData.trim();
        return { value: trimmed, isVisible: trimmed.length > 0 };
    }
    if (typeof fieldData === 'object') {
        const val = typeof fieldData.value === 'string' ? fieldData.value.trim() : (fieldData.value ? String(fieldData.value).trim() : '');
        const isVis = fieldData.isVisible !== false; // defaults to true unless explicitly false
        return { value: val, isVisible: isVis && val.length > 0 };
    }
    return { value: '', isVisible: false };
};
